export const accountSettingsPermissions = ["Owner", "Admin"];
export const accountUsersPermissions = ["Owner", "Admin"];
export const subscriptionPermissions = ["Owner"];
export const deleteAccountPermissions = ["Owner"];
export const affinitySettingsPermissions = ["Owner", "Admin"];
